import * as commonEnums from '../../../enums';

export const coderConfig: CMxAPI.ConfigurationSection[] = [
  {
    id: 145,
    section: 'coder_config',
    keyname: 'amplify_invoice_types',
    values: [
      {
        id: 642,
        value: '',
        jsonValue: {
          invoice_type_order: ['assembled', 'mapped', 'clinical']
        },
        tenantId: '*',
        configurationKeyname: 'amplify_invoice_types',
        configurationId: 145,
        version: 0,
        serviceLines: ['Radiology'],
        createdDate: null,
        updatedDate: null,
        sourceType: null
      }
    ]
  },
  {
    id: 145,
    section: 'coder_config',
    keyname: commonEnums.ConfigurationKeyName.MULTI_CODESET_GENERAL,
    values: [
      {
        id: 642,
        value: 'true',
        jsonValue: {},
        tenantId: '*',
        configurationKeyname:
          commonEnums.ConfigurationKeyName.MULTI_CODESET_GENERAL,
        configurationId: 145,
        version: 0,
        serviceLines: ['*'],
        createdDate: null,
        updatedDate: null,
        sourceType: null
      }
    ]
  }
];
